import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Efeito para detectar o Scroll e mudar a cor da navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      // ANIMAÇÃO 1: Slide Down ao carregar a página
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}

      // LÓGICA DO SCROLL: Se desceu (scrolled), fica escuro/blur. Se tá no topo, fica transparente.
      className={`fixed w-full z-50 transition-all duration-300 ${scrolled
          ? "bg-conectiva-navy/90 backdrop-blur-md border-b border-white/10 shadow-lg py-0"
          : "bg-transparent border-b border-transparent py-4"
        }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">

          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0, 0)}>
            <img
              src="https://somosconexaosocial.org/connectiva-img/logo.jpg"
              alt="Logo Conectiva"
              className="h-10 w-auto rounded-md shadow-md"
            />
            <span className="text-xl font-bold text-white tracking-tighter hidden sm:block">
              CONNECTIVA<span className="text-conectiva-lime">.</span>
            </span>
          </div>

          {/* Menu Desktop */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {['O Curso', 'Vantagens', 'Infraestrutura', 'FAQ'].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase().replace(" ", "")}`}
                  className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition hover:bg-white/5"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>

          {/* Botão CTA Desktop */}
          <div className="hidden md:block">
            <motion.a
              href="https://wa.me/5581992723717"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center gap-2 border border-conectiva-lime text-conectiva-lime px-4 py-2 rounded-full font-bold text-sm hover:bg-conectiva-lime hover:text-conectiva-navy transition duration-300 shadow-[0_0_15px_rgba(204,255,0,0.2)]"
            >
              <Phone size={16} />
              Falar no WhatsApp
            </motion.a>
          </div>

          {/* Botão Mobile (Hamburguer) */}
          <div className="-mr-2 flex md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-200 hover:text-white p-2 rounded-md hover:bg-white/10 transition"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* --- MENU MOBILE ANIMADO --- */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden bg-conectiva-navy/95 border-b border-white/10 overflow-hidden backdrop-blur-xl"
          >
            <div className="px-4 pt-2 pb-6 space-y-2">
              {['O Curso', 'Vantagens', 'Infraestrutura', 'FAQ'].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase().replace(" ", "")}`}
                  onClick={() => setIsOpen(false)} // Fecha o menu ao clicar
                  className="text-gray-300 hover:text-white hover:bg-white/5 block px-3 py-3 rounded-lg text-base font-medium transition border-l-4 border-transparent hover:border-conectiva-lime"
                >
                  {item}
                </a>
              ))}

              <div className="pt-4">
                <a
                  href="https://wa.me/5581992723717"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full flex items-center justify-center gap-2 bg-conectiva-lime text-conectiva-navy px-4 py-3 rounded-lg font-bold shadow-lg active:scale-95 transition"
                >
                  <Phone size={18} />
                  Falar no WhatsApp
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
}